'use client';

import type { AnalyticsPort } from '@/core/ports/analytics';

export const noopAnalytics: AnalyticsPort = {
  pageView: () => {},
  track: () => {},
  identify: () => {},
};
